/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SkillListResponse } from '../../models/skill-list-response';

export interface GetSkills$Params {

/**
 * The type of skill that we want in the response.
 */
  skill_type?: string;
}

export function getSkills(http: HttpClient, rootUrl: string, params?: GetSkills$Params, context?: HttpContext): Observable<StrictHttpResponse<SkillListResponse>> {
  const rb = new RequestBuilder(rootUrl, getSkills.PATH, 'get');
  if (params) {
    rb.query('skill_type', params.skill_type, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SkillListResponse>;
    })
  );
}

getSkills.PATH = '/api/v1/skills';
